<template>
  <b-popover
    :target="targetId"
    triggers="click"
    placement="top"
    variant="warning"
    ref="confirmationExpirePopover"
  >
    <template #title>Atenção</template>
    Deseja realmente expirar o acesso ao usuário <b>{{ targetEmail }}</b
    >? <br /><br />
    Após a expiração, será necessário solicitar um novo acesso ao usuário pelo
    painel de administrador.

    <div class="mt-4">
      <b-button
        size="sm"
        variant="outline-secondary"
        @click="close"
        class="mr-2"
        ><i class="far fa-times-circle mr-1"></i> Fechar
      </b-button>
      <b-button
        size="sm"
        variant="danger"
        @click="
          () => {
            $emit('expire');
            close();
          }
        "
      >
        <i class="fas fa-check mr-1"></i>Confirmar
      </b-button>
    </div>
  </b-popover>
</template>

<script>
export default {
  name: 'ConfirmationExpire',
  emits: ['expire'],
  props: {
    targetId: {
      type: String,
      required: true,
    },
    targetEmail: {
      type: String,
      required: true,
    },
  },
  methods: {
    open() {
      this.$refs.confirmationExpirePopover.$emit('open');
    },
    close() {
      this.$refs.confirmationExpirePopover.$emit('close');
    },
  },
};
</script>
